/* eslint-disable no-undef */
function onValidate() {
  const email = $('#field_1_3 input');
  const mobileNumber = $('#field_1_5 input');
  const privacyPolicy = $('#field_1_13 input');

  function validateAll() {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return email.val() !== ''
      && emailRegex.test(email.val())
      && mobileNumber.val() !== '' && privacyPolicy.is(':checked');
  }

  function submitValid() {
    $('#gform_submit_button_1').attr('disabled', !validateAll());
  }
  if (email.length && mobileNumber.length && privacyPolicy.length) {
    email.on('input', () => submitValid());
    mobileNumber.on('change', () => submitValid());
    privacyPolicy.on('change', () => submitValid());

    submitValid();
  }
}

function generateRandomNumber() {
  const array = new Uint32Array(1);
  window.crypto.getRandomValues(array);
  return array[0] % 100000;
}

function paymentForm() {
  let randNo = generateRandomNumber();

  // Online Payment
  $('.form_input').on('focusout', function () {
    let tid = $('input[name="p1"]').attr('value');
    let refno = $('input[name="p2"]').attr('value');
    let desc = $('input[name="p3"]').attr('value');
    let getAmount = $('#ctl00_ContentPlaceHolder1_txtAmount').val();

    $('#p4').attr('value', getAmount);
    let amount = $('input[name="p4"]').attr('value');
    let Md5Key = 'Mancosadubais007';

    let kChain = tid + refno + desc + amount + Md5Key;
    $('#newMD').attr('value', MD5(kChain));

    if ($('#newstudent').is(':checked')) {
      $('#refNO').attr('value', $('#ctl00_ContentPlaceHolder1_txtfullname').val() + ' - ' + randNo);
    }
    else {
      $('#refNO').attr('value', $('#ctl00_ContentPlaceHolder1_txtstudentno').val() + ' - ' + randNo);
    }
  });

  $('input[name=student]').on('click', function () {
    if ($(this).attr('id') == 'newstudent') {
      $('.currstudent-hide').slideUp();
      $('#refNO').attr('value', '');
    } else {
      $('.currstudent-hide').slideDown();
    }
  });

  // Validation
  $('form.payment-form').validate({
    errorClass: 'payment-error',
    errorElement: 'div',
    submitHandler: function (form) {
      form.submit();
    }
  });

  // Replace with concise character class syntax
  $('#ctl00_ContentPlaceHolder1_txtcontactno, #ctl00_ContentPlaceHolder1_txtAmount').on('input', function () {
    $(this).val($(this).val().replace(/\D/g, ''));
  });

  // Terms and conditions checkbox logic
  $('#ctl00_ContentPlaceHolder1_btnProceed').prop('disabled', true);

  $('#termsconditions').change(function () {
    if (this.checked) {
      $('#ctl00_ContentPlaceHolder1_btnProceed').prop('disabled', false);
    } else {
      $('#ctl00_ContentPlaceHolder1_btnProceed').prop('disabled', true);
    }
  });
}

export { onValidate, paymentForm };
